export default __webpack_public_path__ + "static/media/consent-phishing.e155fd04.svg";